// tofix: https://tt.sankuai.com/ticket/detail?id=4026992
// https://tt.sankuai.com/ticket/detail?id=4020772
var __vue_render__ = function __vue_render__() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('a', _vm._g(_vm._b({}, 'a', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

export default {
  render: __vue_render__,

  staticRenderFns: __vue_staticRenderFns__,

  name: 'Link'
};